"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var React = require("react");
var Alert = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14" },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#FECA63", d: "M5.7630034,1.44919786 L0.0765242105,11.7165775 C-0.181952117,12.315508 0.248841762,13 0.851953191,13 L12.1387528,13 C12.828023,13 13.1726581,12.315508 12.9141818,11.7165775 L7.22770259,1.44919786 C6.96922626,0.85026738 6.10763851,0.85026738 5.7630034,1.44919786 Z" }),
        React.createElement("path", { fill: "#000", d: "M7,11 L7,12 L6,12 L6,11 L7,11 Z M7,4 L7,10 L6,10 L6,4 L7,4 Z" })))); };
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map